// extracted by mini-css-extract-plugin
export default {"PointerBox":"state-style-decorators-module__PointerBox--qUZ4B"};